import * as React from "react";
import { Button, Spinner } from "@finster/ui";
import type { FactSetAppType } from "../shared/factset/hostContextService";
import type { OfficeHost } from "../shared/office/officeHost";

interface TaskpaneHostRouterProps {
  host: OfficeHost | null;
  hostDetectionFailed?: boolean;
  onRetryHostDetection?: () => void;
  excelApp: React.ReactNode;
  powerPointApp: React.ReactNode;
}

export function TaskpaneHostRouter({
  host,
  hostDetectionFailed = false,
  onRetryHostDetection,
  excelApp,
  powerPointApp,
}: TaskpaneHostRouterProps) {
  if (host === "excel") return excelApp;
  if (host === "powerpoint") return powerPointApp;

  if (hostDetectionFailed) {
    return (
      <div
        className="flex min-h-screen flex-col items-center justify-center gap-3 bg-background px-6 text-center"
        role="alert"
      >
        <p className="m-0 text-sm text-muted-foreground">
          Unable to detect the FactSet host.
        </p>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onRetryHostDetection}
        >
          Retry
        </Button>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <Spinner size="sm" />
    </div>
  );
}

export function selectFactSetTaskpaneHost(
  appType: FactSetAppType | null,
  bridgeAvailable: boolean
): OfficeHost | null {
  if (appType === "spreadsheet") return "excel";
  if (appType === "presentation") return "powerpoint";
  return bridgeAvailable ? null : "powerpoint";
}
